import type { ReactNode } from "react";
import type { SentimentText } from "@acto/genui-components-schema";
import { CardHeadline, Header, MetaLabel } from "@acto/taskpane/field-sales-2/components/primitives/Card";
import { SentimentColor } from "./SentimentColor";

interface CardHeaderProps {
  label?: SentimentText | null;
  headline: string;
  children?: ReactNode;
}

export function CardHeader({ label, headline, children }: CardHeaderProps) {
  return (
    <Header>
      {label && (
        <MetaLabel>
          <SentimentColor sentiment={label.sentiment ?? "neutral"}>{label.text}</SentimentColor>
        </MetaLabel>
      )}
      <CardHeadline>{headline}</CardHeadline>
      {children}
    </Header>
  );
}
